__turbopack_context__.v({
  "actionCol": "dataTable-module-scss-module__jW_vcq__actionCol",
  "actionItem": "dataTable-module-scss-module__jW_vcq__actionItem",
  "dataTable": "dataTable-module-scss-module__jW_vcq__dataTable",
  "dataTableContainer": "dataTable-module-scss-module__jW_vcq__dataTableContainer",
  "dataTableHeaderIcon": "dataTable-module-scss-module__jW_vcq__dataTableHeaderIcon",
  "dataTableOuter": "dataTable-module-scss-module__jW_vcq__dataTableOuter",
  "draggableCol": "dataTable-module-scss-module__jW_vcq__draggableCol",
  "emptyMessage": "dataTable-module-scss-module__jW_vcq__emptyMessage",
  "expandableChildrenRow": "dataTable-module-scss-module__jW_vcq__expandableChildrenRow",
  "expandableRow": "dataTable-module-scss-module__jW_vcq__expandableRow",
  "expandedRow": "dataTable-module-scss-module__jW_vcq__expandedRow",
  "expandedTableRow": "dataTable-module-scss-module__jW_vcq__expandedTableRow",
  "highlightedRow": "dataTable-module-scss-module__jW_vcq__highlightedRow",
  "inputCol": "dataTable-module-scss-module__jW_vcq__inputCol",
  "isActionDisabled": "dataTable-module-scss-module__jW_vcq__isActionDisabled",
  "isActionItemHoveredVisible": "dataTable-module-scss-module__jW_vcq__isActionItemHoveredVisible",
  "isActionItemVisible": "dataTable-module-scss-module__jW_vcq__isActionItemVisible",
  "isAsc": "dataTable-module-scss-module__jW_vcq__isAsc",
  "isDesc": "dataTable-module-scss-module__jW_vcq__isDesc",
  "isDraggingColumn": "dataTable-module-scss-module__jW_vcq__isDraggingColumn",
  "isHoverable": "dataTable-module-scss-module__jW_vcq__isHoverable",
  "isRowBorderTop": "dataTable-module-scss-module__jW_vcq__isRowBorderTop",
  "isSecondaryTable": "dataTable-module-scss-module__jW_vcq__isSecondaryTable",
  "isSortable": "dataTable-module-scss-module__jW_vcq__isSortable",
  "isStripedEven": "dataTable-module-scss-module__jW_vcq__isStripedEven",
  "isStripedOdd": "dataTable-module-scss-module__jW_vcq__isStripedOdd",
  "isVisible": "dataTable-module-scss-module__jW_vcq__isVisible",
  "noWrap": "dataTable-module-scss-module__jW_vcq__noWrap",
  "nowrapCells": "dataTable-module-scss-module__jW_vcq__nowrapCells",
  "scrollableBody": "dataTable-module-scss-module__jW_vcq__scrollableBody",
  "sortable": "dataTable-module-scss-module__jW_vcq__sortable",
  "stickyDataTableContainer": "dataTable-module-scss-module__jW_vcq__stickyDataTableContainer",
  "stickyLeftTableContainer": "dataTable-module-scss-module__jW_vcq__stickyLeftTableContainer",
});
